import Container from "react-bootstrap/esm/Container";

import "./footer.css";

const AppFooter = () => {
  return (
    <Container fluid className="footer">
      <div className="copyright">Nishanth Moolam &copy; 2023</div>
    </Container>
  );
};

export default AppFooter;
